module.exports = __webpack_public_path__ + "img/refunded-seal.baa20727.png";